import React from 'react';
import { Check, Star } from 'lucide-react';
import { packages } from '../mockData';

const PackagesSection = () => {
  return (
    <section id="packages" className="section-padding bg-section">
      <div className="container">
        <div className="text-center mb-12">
          <h2 className="heading-1 mb-4">Package Deals</h2>
          <p className="body-large max-w-3xl mx-auto">
            Affordable packages designed to meet your healthcare needs.
          </p>
        </div>

        <div className="packages-grid">
          {packages.map((pkg) => (
            <div 
              key={pkg.id} 
              className={`package-card ${pkg.popular ? 'popular' : ''}`}
            >
              {pkg.popular && (
                <div className="package-badge">
                  <Star size={14} fill="currentColor" />
                  <span>Most Popular</span>
                </div>
              )}
              
              <div className="package-header">
                <h3 className="heading-2">{pkg.name}</h3>
                <p className="body-small text-muted">{pkg.duration}</p>
              </div>

              <div className="package-price">
                <span className="price-amount">{pkg.price}</span>
              </div>

              <ul className="package-features">
                {pkg.features.map((feature, index) => (
                  <li key={index} className="package-feature-item">
                    <Check size={20} className="feature-check" />
                    <span className="body-medium">{feature}</span>
                  </li>
                ))}
              </ul>

              {pkg.deposit !== 'N/A' && (
                <p className="package-deposit body-small">
                  Deposit required: {pkg.deposit}
                </p>
              )}

              <a href="#booking" className="btn-primary w-full">
                Book Now
              </a>
            </div>
          ))}
        </div>

        <div className="mt-12 important-info-card">
          <h3 className="heading-3 mb-4">Important Information</h3>
          <ul className="info-list">
            <li className="body-medium">
              <strong>Additional charges</strong> may apply for travel, medication, medical equipment and laboratory tests.
            </li>
            <li className="body-medium">
              A <strong>non-refundable deposit</strong> is required to confirm appointments: R200 for home visits / R100 for virtual consultations.
            </li>
            <li className="body-medium">
              <strong>Proof of payment</strong> must be sent via email or WhatsApp before the appointment is confirmed.
            </li>
            <li className="body-medium">
              <strong>Medical aid billing is <span style={{ color: 'var(--medical-red)' }}>NOT</span> accepted</strong> until further notice. Payments can be made via EFT only.
            </li>
          </ul>
        </div>
      </div>
    </section>
  );
};

export default PackagesSection;
